/**
 *
 * Styles for Form
 *
 */

import styled from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { DhlText, DhlButton } from "@dhl-official/react-library";

export const StyledButtonHintText = styled(DhlText)`
  & > *:is(p, span) {
    max-width: ${(props) => props.maxWidth};
    margin-bottom: 25px;

    @media screen and (min-width: ${breakpoints.tablet}) {
      margin-bottom: 15px;
    }
  }
`;

export const StyledButtonWrapper = styled.div`
  text-align: ${(props) => props.buttonAlignment};
  margin: var(--dui-size-space-10x) auto;

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin: var(--gaq-size-space-35px) auto var(--dui-size-space-10x);
  }

  @media print {
    display: none;
  }
`;

export const StyledButton = styled(DhlButton)`
  display: block;

  & > .styled.md:is(button, a) {
    height: 42px;
    font-size: 1.5rem;
    font-weight: var(--dui-font-weight-bold);
    line-height: var(--dui-size-line-height-2xl);
    min-height: auto;
    padding: var(--dui-size-space-5x) var(--gaq-size-space-30px)
      var(--gaq-size-space-11px);
    width: auto;

    @media screen and (max-width: ${breakpoints.tablet}) {
      width: ${({ stepperEnabled }) => (stepperEnabled ? "100%" : "auto")};
    }

    @media screen and (min-width: ${breakpoints.tablet}) {
      width: auto;
    }
  }
`;

export const StyledMainWrapper = styled.div`
  ${({ stepperEnabled, step }) =>
    stepperEnabled &&
    step === 1 &&
    `
      background-color: var(--dui-color-white-500);
      box-shadow: var(--dui-size-space-0) var(--gaq-size-space-3px)
        var(--dui-size-space-4x) var(--dui-color-gray-300);
      border-radius: var(--dui-size-space-2x);
      margin-bottom: var(--gaq-size-space-30px);
      padding: var(--dui-size-space-10x) var(--dui-size-space-0)
        var(--dui-size-space-5x);
      padding-bottom: var(--dui-size-space-20x);
    `}

  @media print {
    display: none;
  }
`;

export const StepNoteCell = styled.div`
  @media screen and (max-width: ${breakpoints.tablet}) {
    @supports (display: grid) {
      text-align: end;
      grid-column: 12;
      white-space: nowrap;
      font-size: var(--dui-size-font-sm);
      font-weight: var(--dui-font-weight-bold);
      margin-top: var(--dui-size-space-8x);
    }
  }
`;
